import PropTypes from 'prop-types';
import React, { useState, useCallback } from 'react';

import Moment from 'moment-timezone';

import HeaderContainerGrid from '@/components/headerContainer/Grid';
import { HeaderActions, HeaderSeparator, ReportDatePicker, RunButton } from '@/components/reports/header';

const propTypes = {
  dates: PropTypes.object,
  onChange: PropTypes.func,
  sync: PropTypes.func,
  isLoading: PropTypes.bool,
};

export default function OptoutHeader({ children, onChange, dates, isLoading, sync, title }) {
  const [startDate, setStartDate] = useState(Moment(dates.startDate))
  const [endDate, setEndDate] = useState(Moment(dates.endDate))

  const handleChangeDates = useCallback(({ startDate, endDate }) => {
    setStartDate(startDate)
    setEndDate(endDate)
    if (startDate && endDate) {
      onChange({ startDate, endDate })
    }
  })

  return <>
    <HeaderContainerGrid title={`${title} Report`}>
      <HeaderActions>
        <ReportDatePicker dates={{ startDate, endDate }} onChange={handleChangeDates} />
        <HeaderSeparator />
        {children}
        <RunButton isLoading={isLoading} disabled={isLoading} onClick={sync} />
      </HeaderActions>
    </HeaderContainerGrid>
  </>
}

OptoutHeader.propTypes = propTypes
